import React from "react";
import { Link } from 'react-router-dom'

class Breadcrumb extends React.Component {

  render() {
    const { currentPage } = this.props;

    return (
      <div className="breadcrumb-nav">
        <a href="/">Home</a><span className="bc-seperator">&#62;</span><a href="/products">Products</a><span className="bc-seperator">&#62;</span><Link to="/products/doors">Doors</Link>{currentPage && <React.Fragment><span className="bc-seperator">&#62;</span><div className="current">{currentPage}</div></React.Fragment>}
      </div>
    );
  }
}

export default Breadcrumb;

